import { Record } from 'immutable';
import StudentGeneralInfo from 'domain/StudentGeneralInfo';

const SessionAttendanceRecord = Record({
  id: undefined,
  studentGeneralInfo: new StudentGeneralInfo(),
  attendanceStatus: undefined,
});

class SessionAttendance extends SessionAttendanceRecord { }

export default SessionAttendance;



// WEBPACK FOOTER //
// ./data/SessionsAttendance/model/model.js